<template>
  <div
    class="component-wraper d-flex flex-column secondary"
    style="width: 100vw"
  >
    <div
      class="primary rounded-pill d-flex align-center justify-start mb-10 mt-4 mx-6 pr-2"
      style="width: fit-content"
      @click="$router.go(-1)"
    >
      <v-btn icon v-if="$route.path.split('/')[1] != 'pois'">
        <v-icon color="white" size="17">mdi-arrow-left</v-icon>
      </v-btn>
      <span
        v-if="$route.path.split('/')[1] != 'pois'"
        class="body-2 white--text pr-1"
      >
        {{ $t("menu.info_settings") }}
      </span>
    </div>

    <div
      class="white--text mb-4 px-6"
      style="font-size: 16px; font-weight: bold"
    >
      {{ $t("home.welcome") }}
    </div>

    <div
      v-html="$t('home.description')"
      class="white--text px-6 mb-4"
      style="font-size: 15px"
    ></div>

    <!-- <img src="@/assets/waves.png" class="waves-image" /> -->
    <!-- <div class="espa-logo" style="transition: opacity 3s ease">
      <img src="@/assets/espa.png" style="width: 310px; height: 124.11px" />
    </div> -->
  </div>
</template>

<script>
import { mapState } from "vuex";
export default {
  data() {
    return {};
  },

  computed: {
    ...mapState({
      language: (state) => state.base.mobileLang,
    }),
  },
};
</script>

<style>
.waves-image {
  position: relative;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 300px;
  object-fit: cover;
  object-position: 63% 0;
  margin-bottom: -80px;
  transition: object-position 2.5s ease;
}

.espa-logo {
  width: 100%;
  height: 100px;
  position: absolute;
  bottom: 0;
  left: 0;
  display: flex;
  justify-content: center;
}
</style>